module.exports = __webpack_public_path__ + "img/9788982739774.9bcc8594.jpg";